const makeSnowFlakes = () => {
   const canvas = document.getElementById('snowfall');

   // Check if the canvas element exists
   if (!canvas) {
      console.error('Canvas element not found!');
      return;
   }

   const ctx = canvas.getContext('2d');

   // Set initial canvas size
   canvas.width = window.innerWidth;
   canvas.height = window.innerHeight;

   // Array to hold snowflakes
   let snowflakes = [];

   // Function to create snowflakes
   function createSnowflakes() {
      snowflakes = [];
      for (let i = 0; i < 100; i++) {
         snowflakes.push({
            x: Math.random() * canvas.width,
            y: Math.random() * canvas.height,
            radius: Math.random() * 3 + 1,
            speed: Math.random() * 1 + 1,
            drift: Math.random() * 2 - 1
         });
      }
   }

   // Function to draw snowflakes
   function drawSnowflakes() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.fillStyle = 'white';

      snowflakes.forEach((flake) => {
         ctx.beginPath();
         ctx.arc(flake.x, flake.y, flake.radius, 0, Math.PI * 2);
         ctx.fill();
      });
   }

   // Function to move snowflakes
   function moveSnowflakes() {
      snowflakes.forEach((flake) => {
         flake.y += flake.speed;
         flake.x += flake.drift;

         // Reset snowflake position if it falls out of view
         if (flake.y > canvas.height) {
            flake.y = 0;
            flake.x = Math.random() * canvas.width;
         }

         // Wrap snowflakes horizontally
         if (flake.x > canvas.width) flake.x = 0;
         if (flake.x < 0) flake.x = canvas.width;
      });
   }

   // Animation loop
   function animate() {
      drawSnowflakes();
      moveSnowflakes();
      requestAnimationFrame(animate);
   }

   // Resize canvas and recreate snowflakes on window resize
   window.addEventListener('resize', () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
      createSnowflakes();
   });

   // Initialize snowflakes and start animation
   createSnowflakes();
   animate();
};

document.addEventListener('DOMContentLoaded', () => {
   makeSnowFlakes();

   const submit = {
      container: document.querySelector('.submit-message'),
      success: document.getElementById('submit-success'),
      error: document.getElementById('submit-error'),
   };

   const register = {
      form: document.getElementById('register-form'),
      answer: document.getElementById('register-answer'),
      name: document.getElementById('register-name'),
      phone: document.getElementById('register-phone'),
      submit: document.getElementById('register-submit'),
   };
   
   const modal = {
      container: document.getElementById('modal-container'),
      close: document.getElementById('modal-close'),
      open: document.getElementById('modal-open'),
   };

   // open modal
   modal.open.addEventListener('click', () => {
      modal.container.classList.toggle('hidden');
      modal.close.focus();
   })

   // hide modal if click outside
   modal.container.addEventListener('click', (event) => {
      if (event.target.tagName !==  'IMG') {
         modal.container.classList.toggle('hidden');
         modal.open.focus();
      }
   });

   // hide modal
   document.addEventListener("keydown", (e) => {
      // keypress "enter" on X icon
      if (e.key === 'Enter' && e.target.id === modal.close.id) {
         e.preventDefault();
         modal.container.classList.add('hidden');
         modal.open.focus();
      }
      
      // keypress "esc"
      if (e.key === 'Escape') {
         modal.container.classList.add('hidden');
         modal.open.focus();
      }
   });

   // register answer
   register.submit.addEventListener('click', (event) => {
      // HTML validation
      if (register.form.checkValidity()) {
         event.preventDefault();

         const urlParams = {
            campaign: 'jul-2025',
            answer: register.answer.value,
            name: register.name.value,
            tel: register.phone.value,
         };

         fetch(
            `/_/service/no.tine.paskekrim/register?${new URLSearchParams(
               urlParams
            )}`
         )
            .then((response) => {
               // hide form
               register.form.classList.add('hidden');
               submit.container.classList.remove('hidden');
               submit.container.scrollIntoView({ behavior: 'smooth', block: 'center' });

               if (response.status.toString().startsWith('2')) {
                  // success
                  submit.success.classList.remove('hidden');
                  submit.error.classList.add('hidden');
               } else {
                  // error
                  submit.success.classList.add('hidden');
                  submit.error.classList.remove('hidden');

                  console.error('-------- error --------');
                  console.error(response);
               }
            })
            .catch((error) => {
               submit.container.classList.remove('hidden');
               submit.container.scrollIntoView({ behavior: 'smooth', block: 'start' });
               submit.error.classList.remove('hidden');
               register.form.classList.add('hidden');
               submit.success.classList.add('hidden');

               console.error('-------- error --------');
               console.error(error);
            });
      }
   });
});
